export default {
  moduleName: 'teacher',
  apis: [
      {
          funName: 'info',
          methodType: 'get',
          url: 'info'
      },
      {
          funName: 'findList',
          methodType: 'get',
          url: 'list'
      },
      {
        funName: 'queryList',
        methodType: 'post',
        url: 'list'
      },
      {
          funName: 'findPage',
          methodType: 'get',
          url: 'page'
      },
      {
          funName: 'insert',
          methodType: 'post',
          url: 'insert'
      },
      {
          funName: 'update',
          methodType: 'post',
          url: 'save'
      },
      {
          funName: 'query',
          methodType: 'post',
          url: 'page'
      },
      {
        funName: 'deleteTeacher',
        methodType: 'get',
        url: 'delete'
      },
      {
        funName: 'findSubmitStudents',
        methodType: 'get',
        url: 'nominate/students'
      }
      
  ]
}